export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7,
};



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/date/DateConstants.js